import {
  CALENDAR_ADMIN_RESET,
  CALENDAR_GET_LIST_INIT,
  CALENDAR_GET_LIST_SUCCESS,
  CALENDAR_GET_LIST_FAILURE,
  CALENDAR_GET_RULES_LIST_INIT,
  CALENDAR_GET_RULES_LIST_SUCCESS,
  CALENDAR_GET_RULES_LIST_FAILURE,
  CALENDAR_ADMIN_SAVE_CALENDAR_INIT,
  CALENDAR_ADMIN_SAVE_CALENDAR_SUCCESS,
  CALENDAR_ADMIN_SAVE_CALENDAR_FAILURE,
  CALENDAR_ADMIN_SAVE_CALENDAR_DATA_BY_KEY,
  CALENDAR_ADMIN_SAVE_CALENDAR_RESET,
  CALENDAR_ADMIN_SAVE_RULE_INIT,
  CALENDAR_ADMIN_SAVE_RULE_SUCCESS,
  CALENDAR_ADMIN_SAVE_RULE_FAILURE,
  CALENDAR_ADMIN_SAVE_RULE_DATA_BY_KEY,
  CALENDAR_ADMIN_SAVE_RULE_RESET,
  CALENDAR_ADMIN_GET_LABORAL_DAYS_INIT,
  CALENDAR_ADMIN_GET_LABORAL_DAYS_SUCCESS,
  CALENDAR_ADMIN_GET_LABORAL_DAYS_FAILURE,
  CALENDAR_DELETE_INIT,
  CALENDAR_DELETE_PREPARE_INIT,
  CALENDAR_DELETE_SUCCESS,
  CALENDAR_DELETE_FAILURE,
  CALENDAR_RULE_DELETE_INIT,
  CALENDAR_RULE_DELETE_PREPARE_INIT,
  CALENDAR_RULE_DELETE_SUCCESS,
  CALENDAR_RULE_DELETE_FAILURE,
} from './types';
import ActionsTooling from '../../../tooling/actionsTooling';
import Constants from '../../../definitions/constants';
import FilesTooling from '../../../tooling/filesTooling';
import { intl } from '../../../locales/localesConfig';

export function reset() {
  return {
    type: CALENDAR_ADMIN_RESET
  };
}

export function getCalendarsList() {
  let params = {
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: [],
    searches_are: [],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: CALENDAR_GET_LIST_INIT,
      params: params,
      paging: false,
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calendar",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CALENDAR_GET_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CALENDAR_GET_LIST_FAILURE, error));
    }  
  };
}

export function getRulesList(calendar_id) {
  let params = {
    order_fields: ["priority", "created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC, Constants.crudGenerator.orderTypes.DESC],
    fields_are: [],
    searches_are: [],
    per_page: Constants.interface.fullListPageSize,
    calendar_id: calendar_id
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: CALENDAR_GET_RULES_LIST_INIT,
      params: params,
      paging: false,
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calendar/ruleslist",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CALENDAR_GET_RULES_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CALENDAR_GET_RULES_LIST_FAILURE, error));
    }  
  };
}

export function saveCalendarEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(CALENDAR_ADMIN_SAVE_CALENDAR_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calendar/save",
        "POST",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CALENDAR_ADMIN_SAVE_CALENDAR_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CALENDAR_ADMIN_SAVE_CALENDAR_FAILURE, error));
    }  
  };
}
export function saveRuleEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(CALENDAR_ADMIN_SAVE_RULE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calendar/saverule",
        "POST",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CALENDAR_ADMIN_SAVE_RULE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CALENDAR_ADMIN_SAVE_RULE_FAILURE, error));
    }  
  };
}

export function setSaveRuleEntityDataByKey(key, value) {
  return {
    type: CALENDAR_ADMIN_SAVE_RULE_DATA_BY_KEY,
    key: key,
    value: value
  };
}

export function resetSaveCalendarEntity(data) {
  return {
    type: CALENDAR_ADMIN_SAVE_CALENDAR_RESET,
    data: data 
  };
}

export function resetSaveRulesCalendarEntity(data) {
  return {
    type: CALENDAR_ADMIN_SAVE_RULE_RESET,
    data: data 
  };
}

export function getCalendarLaboralDays(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(CALENDAR_ADMIN_GET_LABORAL_DAYS_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calendar/laboraldays",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CALENDAR_ADMIN_GET_LABORAL_DAYS_SUCCESS, resp));
    } 
    catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CALENDAR_ADMIN_GET_LABORAL_DAYS_FAILURE, error));
    }  
  };
}

export function setSaveCalendarEntityDataByKey(key, value) {
  return {
    type: CALENDAR_ADMIN_SAVE_CALENDAR_DATA_BY_KEY,
    key: key,
    value: value
  };
}

export function prepareDeleteCalendarEntity(id) {
  return {
    type: CALENDAR_DELETE_PREPARE_INIT,
    id: id
  };
}

export function deleteCalendarEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(CALENDAR_DELETE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calendar/delete",
        "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CALENDAR_DELETE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CALENDAR_DELETE_FAILURE, error));
    }  
  };
}

export function prepareDeleteRuleEntity(id) {
  return {
    type: CALENDAR_RULE_DELETE_PREPARE_INIT,
    id: id
  };
}

export function deleteRuleEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(CALENDAR_RULE_DELETE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calendar/deleterule",
        "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CALENDAR_RULE_DELETE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CALENDAR_RULE_DELETE_FAILURE, error));
    }  
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/calendarAdmin/index.js